import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type DisclaimerProps = {
  sourceUrl: string;
};
export function Disclaimer({
  sourceUrl
}: DisclaimerProps) {
  const reduce = useReducedMotion();
  const linkClass = 'underline decoration-cream/40 underline-offset-2 hover:decoration-cream focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-hibiscus rounded-sm';
  return <motion.footer initial={reduce ? false : {
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.25,
    delay: 0.35,
    ease: 'easeOut'
  }} className="rounded-full bg-jungle-deep/85 px-4 py-2 text-center text-[11px] leading-snug text-cream/75 backdrop-blur-sm" data-id="element-8" data-mp="3qkp3s40rleh5">
      Fan-made, not affiliated with HBO. “Aloha!” by Cristóbal Tapia de Veer ·{' '}
      <a href={sourceUrl} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-9" data-mp="deozfrjqwmiw">
        Source
      </a>{' '}
      ·{' '}
      <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-10" data-mp="i5xb6u8jsjz8">
        YouTube Terms
      </a>
    </motion.footer>;
}